import script from "./PurchaseHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseHistory.vue?vue&type=script&setup=true&lang=js"

import "@/features/user/styles/operationArea/PurchaseHistory.css?vue&type=style&index=0&id=0902d3bd&scoped=true&lang=css&external"
import "@/features/user/styles/operationArea/OperationAreaTheme.css?vue&type=style&index=1&id=0902d3bd&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0902d3bd"]])

export default __exports__